import { useState } from 'react';
import { ProgramsData } from "../assets"; // Update this path accordingly

const Campaigns = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Get unique categories
  const categories = ['All', ...new Set(ProgramsData.map(item => item.category))];

  // Filter programs based on selected category
  const filteredPrograms = selectedCategory === 'All'
    ? ProgramsData
    : ProgramsData.filter(program => program.category === selectedCategory);

  return (
    <div className='w-full min-h-screen'>
      {/* Header Section */}
      <div className='w-full min-h-[292px] px-4 sm:px-[50px] py-[40px] sm:py-[60px] flex flex-col items-center justify-center gap-[12px] bg-[#EE645A] font-poppins text-center text-[#FFFFFFCC]'>
        <h1 className='font-semibold text-[24px] sm:text-[32px]'>
          Our Programs
        </h1>

        <p className='h-auto mt-3 font-normal text-[16px] sm:text-[20px]'>
          Empowering Tomorrow Through Education, Skills & Community Support
        </p>

        <p className='max-w-[1000px] h-auto mb-0 font-normal text-[14px] sm:text-[20px] mt-3'>
          We believe in creating lasting change through comprehensive programs that address education, health, livelihood, and social welfare. Each initiative is designed to uplift communities and build a brighter future for all.
        </p>
      </div>

      {/* Filter Category Section */}
      <div className='w-full py-8 px-4'>
        <div className='max-w-[1320px] mx-auto flex justify-center'>
          <div className='flex flex-wrap gap-3 justify-center'>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => {
                  setSelectedCategory(category);
                }}
                className={`px-6 py-1 rounded-full text-[12px] transition-all duration-300 ${selectedCategory === category
                  ? 'bg-[#EE645A] text-white'
                  : 'bg-white text-[#000000] border border-[#EE645A]/40 hover:bg-[#FFF0ED]'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Programs Grid Section */}
      <div className='max-w-[1320px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4 py-10 justify-items-center'>

        {filteredPrograms.map((program, idx) => (
          <div
            key={idx}
            className='w-full max-w-[424px] min-h-[422px] bg-[#FFFFFF] rounded-[16px] shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),0_10px_15px_-4px_rgba(0,0,0,0.1)] flex flex-col overflow-hidden'
          >
            {/* Image Section */}
            <img
              src={program.img[0]}
              alt={program.title}
              className='w-full h-[212px] object-cover'
            />

            {/* Content Section */}
            <div className='p-5 flex flex-col flex-grow'>
              {/* Category Badge */}
              <div className="flex justify-center w-full">
                <span className="inline-block bg-[#EE645A] text-white text-[12px] font-medium px-3 py-1 rounded-full mb-2">
                  {program.category}
                </span>
              </div>

              {/* Title */}
              <h2 className='font-medium text-[18px] sm:text-[20px] text-[#000000] leading-tight mb-3 text-center'>
                {program.title}
              </h2>

              {/* Description */}
              <p className='text-[#00000080] font-normal text-[14px] leading-relaxed mb-6 flex-grow line-clamp-2 overflow-hidden text-ellipsis text-center'>
                {program.description}
              </p>

              {/* Learn More Link */}
              {/* <div className='mt-auto'>
                <p className='block text-center text-[#EB5A57] text-[16px] font-medium hover:underline cursor-pointer'>
                  Learn More →
                </p>
              </div> */}
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Campaigns;